import { Button, Modal } from "@mui/material";

const NewsModal = ({ open, setOpen, newsData }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        zIndex: 10000, // Daha yüksek z-index değeri
        outline: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          backgroundColor: "var(--lighterBg)",
          maxWidth: "900px", // Daha büyük genişlik
          width: "95%", // Ekranın daha fazla alanını kapla
          overflow: "auto",
          borderRadius: "var(--wrapperBorderRadius)",
          outline: "none",
          maxHeight: "95vh", // Daha büyük yükseklik
          padding: "30px", // Daha fazla padding
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)", // Daha belirgin gölge
        }}
      >
        {/* Haber Görseli */}
        {newsData?.image && (
          <figure
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "var(--pastelBlue)",
              borderRadius: "var(--wrapperBorderRadius)",
              overflow: "hidden",
              margin: "0 0 20px 0",
            }}
          >
            <img
              src={newsData.image}
              alt="Haber Görseli"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "300px",
                objectFit: "cover"
              }}
            />
          </figure>
        )}

        <div
          style={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "var(--gap)",
          }}
        >
          {/* Haber Başlığı */}
          <h1
            style={{
              fontSize: "28px",
              lineHeight: "32px",
              color: "var(--btnBgBlue)",
              textAlign: "center",
              margin: "0 0 20px 0",
              fontWeight: "600",
            }}
          >
            {newsData?.title || "Önemli Duyuru"}
          </h1>

          {/* Haber Tarihi */}
          {newsData?.date && (
            <p
              style={{
                fontSize: "14px",
                color: "var(--textSecondary)",
                textAlign: "center",
                margin: "0 0 20px 0",
                fontStyle: "italic",
              }}
            >
              {newsData.date}
            </p>
          )}

          {/* Haber İçeriği */}
          <div
            style={{
              fontSize: "16px",
              lineHeight: "24px",
              color: "var(--text)",
              textAlign: "justify",
              marginBottom: "20px",
            }}
          >
            {newsData?.content ? (
              // Eğer content bir array ise paragraflar halinde göster
              Array.isArray(newsData.content) ? (
                newsData.content.map((paragraph, index) => (
                  <p
                    key={index}
                    style={{
                      marginBottom: "15px",
                      textAlign: "center",
                    }}
                  >
                    {paragraph}
                  </p>
                ))
              ) : (
                // Tek bir string ise direkt göster
                <p style={{ textAlign: "center" }}>{newsData.content}</p>
              )
            ) : (
              // Varsayılan içerik
              <>
                <p style={{ textAlign: "center", marginBottom: "15px" }}>
                  Değerli iyziShip üyelerimiz,
                </p>
                <p style={{ textAlign: "center", marginBottom: "15px" }}>
                  Sizlere daha iyi hizmet verebilmek için sistemimizde önemli güncellemeler yaptık.
                </p>
                <p style={{ textAlign: "center", marginBottom: "15px" }}>
                  Yeni özellikler ve iyileştirmeler hakkında detaylı bilgi almak için
                  destek ekibimizle iletişime geçebilirsiniz.
                </p>
                <p style={{ textAlign: "center", marginBottom: "15px" }}>
                  BOL SATIŞLAR! 🚀
                </p>
                <p style={{ textAlign: "center" }}>
                  iyziTeam
                </p>
              </>
            )}
          </div>

          {/* Ek Bilgiler */}
          {newsData?.additionalInfo && (
            <div
              style={{
                backgroundColor: "var(--lightBg)",
                padding: "20px",
                borderRadius: "var(--wrapperBorderRadius)",
                marginBottom: "20px",
              }}
            >
              <h3
                style={{
                  fontSize: "18px",
                  color: "var(--btnBgBlue)",
                  textAlign: "center",
                  marginBottom: "10px",
                }}
              >
                Önemli Bilgiler
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "var(--text)",
                  textAlign: "center",
                  lineHeight: "20px",
                }}
              >
                {newsData.additionalInfo}
              </p>
            </div>
          )}

          {/* Kapatma Butonu */}
          <Button
            className="iyzi-button-blue"
            onClick={handleClose}
            style={{
              fontSize: "16px",
              padding: "12px 24px",
              marginTop: "20px",
            }}
          >
            Kapat
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NewsModal;
